export default {
  LBL_ACTION: 'Action',
  LBL_ACTIONS: 'Actions',
  LBL_LOADING: 'Loading...',
  LBL_LOADING_REPORT_INFORMATION: 'Loading Aviation Service...',
  LBL_CANCEL: 'Cancel',
  LBL_CLOSE: 'Close',
  LBL_CHANGE_LOG: 'Change Log',
  LBL_SAVE: 'Save',
  LBL_SAVE_CLOSE: 'Save & Close',
  LBL_OKAY: 'OK',
  LBL_ADD: 'Add',
  LBL_ADD_FILES: 'Add Files',
  LBL_ADD_SENSITIVE_COMMUNITIES: 'New Sensitive Communities',
  LBL_DELETE_SENSITIVE_COMMUNITIES: 'Delete Sensitive Communities',
  LBL_EDIT_SENSITIVE_COMMUNITIES: 'Edit Sensitive Communities',
  LBL_SENSITIVE_COMMUNITIES: 'Sensitive Community',
  LBL_SENSITIVE_COMMUNITY_PAM_LEAD: 'PAM Lead',
  LBL_EDIT: 'Edit',
  LBL_SUBMIT: 'Submit',
  LBL_REVIEW_SUBMIT: 'Review & Submit',
  LBL_BROWSE: 'Browse',
  LBL_RETURN: 'Return',
  LBL_SAVE_RETURN: 'Save & Return',
  LBL_YES_DELETE: 'Yes, Delete',
  LBL_ADMIN_ADD: 'Add Admin User',
  LBL_ADMIN_EDIT: 'Edit Admin User',
  LBL_ADMIN_DELETE: 'Delete Admin User',
  LBL_ADMIN_EMPLOYEE_EMAIL: 'Email',
  LBL_EMPLOYEE_ID: 'Employee Number',
  LBL_NAME: 'Name',
  LBL_ADMIN_GRANTED_ADMIN_ACCESS_BY: 'Granted Admin Access By',
  LBL_ADMIN_GRANTED_ADMIN_ON: 'Granted Admin On',
  LBL_SEARCH: 'Search',
  LBL_SEARCH_PERSON: 'Lookup person',
  LBL_DESCRIPTION: 'Description',
  LBL_SELECT: 'Select',
  LBL_SELECT_ONE: 'Select One',
  LBL_EDITABLE: 'Editable',
  LBL_DONE: 'Done',

  LBL_ENTER: 'Enter',
  LBL_ENTER_DETAILS: 'Enter Details',
  LBL_EMAIL: 'Email:',
  LBL_EMAIL_SEND: 'Send',
  LBL_EMAIL_SENT: 'Email Sent',
  LBL_EMPLOYEE_COMPANY: 'Company:',
  LBL_EMPLOYEE_COMPANY_NAME: 'Company Name:',
  LBL_EMPLOYEE_DEPARTMENT: 'Department:',
  LBL_EMPLOYEE_JOB_TITLE: 'Title:',
  LBL_EMPLOYEE_EMAIL: 'Email:',
  LBL_EMPLOYEE_EXISTING: 'Existing Employee',
  LBL_EMPLOYEE_NAME: 'Employee Name',
  LBL_EMPLOYEE_NUM: 'Employee Number',
  LBL_EMPLOYEE_NUMBER: 'Employee Number:',
  LBL_EMPLOYEE_PHONE: 'Phone:',
  LBL_EMPLOYEE_REPLACE: 'Replace',
  LBL_EMPLOYEE_REPLACE_WITH: 'Replace With',
  LBL_EMPLOYEE_ROLE: 'Employee Role',
  LBL_EMPLOYEE_MGR_NAME: 'Manager Name:',
  LBL_EMPLOYEE_MGR_E_MAIL: 'Manager Email:',

  LBL_KEY: 'Key',
  LBL_ROLE: 'Role',
  LBL_NEW: 'New',
  LBL_VALUE: 'Value',
  LBL_YEAR: 'Year',
  LBL_YES: 'Yes',
  LBL_NO: 'No',
  LBL_ACTIVE: 'Active',
  LBL_DISPATCH: 'Dispatch',
  LBL_DELETE: 'Delete',
  LBL_UPLOAD: 'Upload',
  LBL_TYPE: 'Type',

  LBL_ALL: 'All ({0})',
  LBL_ALL_FLIGHT_REQUEST: 'All Flight Request',
  LBL_PASSENGER_FLIGHTS: 'Patrol/Passenger ({0})',
  LBL_PASSENGER_INFORMATION: 'Passenger Information',
  LBL_PASSENGER_TYPE: 'Passenger Type',
  LBL_PASSENGER_NAME: 'Passenger Name',
  LBL_STRUCTURE_ID: 'Structure ID',
  LBL_STRUCTURE_IDS: 'Structure ID(s)',
  LBL_LANDING_ZONE_COORDINATE: 'Landing Zone Coordinate',
  LBL_LANDING_ASSURED: 'Landing Assured',
  LBL_ATTACHMENTS: 'Attachments',
  LBL_UPLOAD_MAP: 'Upload Map',
  LBL_OTHER_INFORMATION: 'Other Information/Questions',
  LBL_ADDITIONAL_COMMENT: 'Additional Comments',
  LBL_FLIGHT_AREA: 'Flight Area',
  LBL_CONSTRUCTION_FLIGHTS: 'Construction ({0})',
  LBL_HELICOPTER_FLIGHTS: 'Manned ({0})',
  LBL_DRONE_FLIGHTS: 'Drone ({0})',
  LBL_TABLE_SEARCH: 'Enter Ticket Number',

  LBL_NOTES: 'Notes',
  LBL_REFERENCES: 'Reference',

  LBL_ADD_ROPE_CONDUCTOR: 'New Rope/Conductor Size',
  LBL_DELETE_ROPE_CONDUCTOR: 'Delete Rope/Conductor Size',
  LBL_EDIT_ROPE_CONDUCTOR: 'Edit Rope/Conductor Size',
  LBL_ROPE_SIZE: 'Rope Size',

  LBL_ADD_FLIGHT_TYPE: 'New Flight Type',
  LBL_DELETE_FLIGHT_TYPE: 'Delete Flight Type',
  LBL_EDIT_FLIGHT_TYPE: 'Edit Flight Type',
  LBL_FLIGHT_INFORMATION: 'Flight Information',
  LBL_FLIGHT_TYPE: 'Flight Type',
  LBL_ADD_SENSITIVE_CITIES: 'New Sensitive City',
  LBL_DELETE_SENSITIVE_CITIES: 'Delete Sensitive City',
  LBL_EDIT_SENSITIVE_CITIES: 'Edit Sensitive City',
  LBL_DRONE_AREA: 'Sensitive Drone Area',
  LBL_SENSITIVE_CITY: 'Sensitive City',
  LBL_SENSITIVE_CITY_PAM_LEAD: 'PAM Lead',

  LBL_CND_WO_NUMBER: 'CND - Work Order Number(s)',
  LBL_CND_DISTRICTS: 'CND - Districts',

  LBL_ADD_POLYGON: 'New Polygon',
  LBL_DELETE_POLYGON: 'Delete Polygon',
  LBL_EDIT_POLYGON: 'Edit Polygon',
  LBL_Polygon: 'Polygon',
  LBL_COMMENT: 'Comments',
  LBL_FLIGHT_DESTINATION: 'Flight Destination',
  LBL_TOWN_CITY: 'Town/City',
  LBL_FLIGHT_DISTRICT_DEPARTMENT: 'District/Department',
  LBL_FLIGHT_POLYGON: 'Polygon',
  LBL_PICKUP_LOCATION: 'Pickup Location',
  LBL_COORINATES: 'Coordinates',
  LBL_PASSENGER_COUNT: 'Number of Passenger',
  LBL_POLE_COUNT: 'Number of Poles',
  LBL_FLIGHT_HOURS: 'Flight Hours:',

  LBL_ADD_TAIL_NUMBER: 'New Tail Number',
  LBL_DELETE_TAIL_NUMBER: 'Delete Tail Number',
  LBL_MODIFY_TAIL_NUMBER: 'Edit Tail Number',
  LBL_TAIL_NUMBER: 'Tail Number',

  LBL_ADD_DEPARTMENT: 'New Department',
  LBL_DELETE_DEPARTMENT: 'Delete Department',
  LBL_MODIFTY_DEPARTMENT: 'Edit Department',
  LBL_DEPARTMENT: 'Department',

  LBL_ADD_PILOT: 'New Pilot',
  LBL_DELETE_PILOT: 'Delete Pilot',
  LBL_EDIT_PILOT: 'Edit Pilot',
  LBL_PILOT_NAME: 'Pilot Name',
  LBL_PILOT_PHONE: 'Pilot Phone',

  LBL_AGENCY_NAME: 'Agency Name',
  LBL_AGENCY_RATE: 'Agency Rate',
  LBL_USD: 'USD',
  LBL_ADD_FIRE_AGENCY: 'New Fire Agency',
  LBL_DELETE_FIRE_AGENCY: 'Delete Fire Agency',
  LBL_MODIFY_FIRE_AGENCY: 'Edit Fire Agency',
  LBL_ADD_CONFIGUTATION_SETTINGS: 'New Configuration Settings',
  LBL_DELETE_CONFIGUTATION_SETTINGS: 'Delete Configuration Settings',
  LBL_MODIFY_CONFIGUTATION_SETTINGS: 'Edit Configuration Settings',

  LBL_OPERATOR_NAME: 'Operator Name',
  LBL_OPERATOR_EMAIL: 'Operator Email',
  LBL_ADD_FLIGHT_OPERATOR: 'New Flight Operator',
  LBL_DELETE_FLIGHT_OPERATOR: 'Delete Flight Operator',
  LBL_MODIFY_FLIGHT_OPERATOR: 'Edit Flight Operator',

  LBL_ADD_OPERATOR_PILOT: 'New Operator and Pilot Relationship',
  LBL_DELETE_OPERATOR_PILOT: 'Delete Operator and Pilot Relationship',
  LBL_MODIFY_OPERATOR_PILOT: 'Edit Operator and Pilot Relationship',

  LBL_REQUEST_REQUESTOR_EMPLOYEE: 'Name/Employee Number',
  LBL_REQUEST_POC_EMPLOYEE: 'Name/Employee Number',
  LBL_REQUEST_REQUESTOR_CONTACT: 'Contact Phone',
  LBL_REQUEST_POC_CONTACT: 'Contact Phone',
  LBL_REQUEST_DISTRICT: 'District/Region',
  LBL_REQUEST_CONTACT: 'Contact Phone',
  LBL_REQUEST_FIELD_CONTACT:
    'Is the requestor also going to be the Field Contact?',
  LBL_REQUEST_FIELD_CONTACT_EMPLOYEE:
    'Is the Field Contact person an employee?',

  LBL_DISTRICT_NAME: 'District',
  LBL_PROJECT_NAME: 'Project',
  LBL_DISTRICT_PROJECT: 'District/Project',
  LBL_PURPOSE: 'Purpose of Flight',
  LBL_DISTRICT_SDGE_CONTRACTOR: 'SCG/Contractor',
  LBL_DISTRICT_RELATIONSHIP: 'SCG/Contractor',
  LBL_ADD_DISTRICT: 'New District/Project',
  LBL_EDIT_DISTRICT: 'Edit District/Project',
  LBL_DELETE_DISTRICT: 'Delete District/Project',
  LBL_MODIFY_DISTRICT: 'Edit District/Project and Company relationship',
  LBL_REQUEST_FIELD_CONTACT_NAME: 'Field Contact Name',
  LBL_REQUEST_DEPARTMENT: 'Department',
  LBL_REQUEST_COMPANY: 'Company',
  LBL_REQUEST_EMAIL: 'Email',

  LBL_REQUEST_FLIGHT_DATE: 'Requested Flight Date',
  LBL_REQUEST_FLIGHT_START_DATE: 'Requested Flight Start Date',
  LBL_REQUEST_FLIGHT_END_DATE: 'Requested Flight End Date',
  LBL_REQUEST_FLIGHT_START_TIME: 'Start Time',
  LBL_REQUEST_FLIGHT_DURATION: 'Estimate Duration',
  LBL_REQUEST_FLIGHT_RELEASE_STANDBY_TIME:
    'Estimated time of release for jobs with standby time',
  LBL_REQUEST_FLIGHT_STANDBY_HOURS: 'Stand By Hours',
  LBL_REQUEST_FLIGHT_REQUIREMENT:
    'All Flight Requests should be submitted 10 days ahead of flight date unless pre-approved or emergency status',

  LBL_REQUEST_FLIGHT_DEPARTURE: 'Departure Time',
  LBL_REQUEST_FLIGHT_ARRIVAL: 'Arrival Time',
  LBL_REQUEST_FLIGHT_START: 'Flight Start',
  LBL_REQUEST_FLIGHT_END: 'Flight End',
  LBL_REQUEST_FLIGHT_HOURS: 'Flight Hours',

  LBL_REQUEST_COST_CENTER: 'Cost Center',

  LBL_REQUEST_WORK_ORDER_NUMBER: 'W/O Number',
  LBL_REQUEST_IO_NUMBER: 'IO Number',
  LBL_REQUEST_PLAN_CATEGORY: 'Plan Category',

  LBL_TICKET_NO: 'ticket no.',
  LBL_CANCELLED: 'Cancelled',
  LBL_PENDING_APPROVAL: 'Pending Approval',

  LBL_REQUEST_CANCELLED: 'Cancelled',
  LBL_REQUEST_PENDING: 'Submitted for approval',
  LBL_BY: 'by',
  LBL_LOCATION: 'Location',
  LBL_REQUESTED: 'Requested',
  LBL_FIELD: 'Field',
  LBL_PROJECT: 'Project Name',
  LBL_PIPELINE_NUMBER: 'Pipeline #',

  LBL_CIRCUIT: 'Tie Lines/Circuits',
  LBL_WORK_TYPE: 'Work Type',
  LBL_REQUESTOR_NAME: 'Requestor Name',
  LBL_DETAILS: 'Details',
  LBL_SHOW_DETAILS: '+ Show details',
  LBL_HIDE_DETAILS: '- Hide details',
  LBL_ADD_FLIGHT_REQUEST: 'New Request',
  LBL_ADD_FIRE_DISPATCH: 'New Dispatch',
  LBL_REQUEST_INFO: 'Request Info',
  LBL_REQUEST_DATE: 'Request Date',
  LBL_REQUEST_RECEIVED_DATE: 'Request Received Date',
  LBL_FLIGHT_DATE_TIME: 'Flight Start Date & Time',
  LBL_FLIGHT_END_DATE: 'Flight End Date',
  LBL_REQUESTOR: 'Requestor',
  LBL_POC_NO: 'Employee Number',
  LBL_POC_NAME: 'Emergency Point of Contact',
  LBL_POC_PHONE: 'Contact Phone',
  LBL_POC_TITLE: 'Title',
  LBL_POC_EMAIL: 'Email',
  LBL_POC_MANAGER_NAME: 'Manager Name',
  LBL_POC_MANAGER_EMAIL: 'Manager Email',
  LBL_POC_DEPT: 'Department',
  LBL_POC_COMPANY: 'Company',
  LBL_DP: 'D/P',
  LBL_JOB_LOCATION: 'Job Location',
  LBL_TAR_STATUS: 'TAR Status',
  LBL_TAR_APPROVAL_DATE: 'TAR Approval Date',
  LBL_TAR_AUTHOR: 'TAR Author',
  LBL_FLIGHT_NO: 'Flight No',
  LBL_STATUS_ACTIONS: 'Status & Actions',
  LBL_STATUS_CHANGE_LOG: 'Status Change Log',
  LBL_DISTRICT_DEPT_PROJECT: 'District/Department/Project',
  LBL_STATUS: 'Status',
  LBL_OPERATOR: 'Operator',
  LBL_TAIL_NO: 'Tail No',
  LBL_FLIGHT_DATE_RANGE: 'Flight Date Range',
  LBL_ACTUAL_FLIGHT_DATE_RANGE: 'Actual Flight Date Range',
  LBL_REQUESTED_BY: 'Requested by',
  LBL_REQUESTED_FLIGHT_TIME: 'Requested Flight Time',
  LBL_CHOOSE_CATEGORY: 'Choose Category',

  LBL_IN_FLIGHT: 'In Flight',
  LBL_DECLINED: 'Declined',
  LBL_APPROVED: 'Approved',
  LBL_FLIGHT_COST: 'Flight Cost',
  LBL_FLIGHT_COST_REQUIRES: 'Requires Flight Cost',
  LBL_COMPLETED: 'Completed',

  LBL_WEIGHT: 'Weight (lbs)',
  LBL_CAMP_PENDLETON_TAR: 'Camp Pendleton TAR Needed',
  LBL_SENSITIVE_CUSTOMER: 'Sensitive Customer',
  LBL_SENSITIVE_FILES: 'Sensitive Customer Files',
  LBL_CULTURAL_RESTRICTION: 'Environmental/Cultural Restriction',
  LBL_CULTURAL_RESTRICTION_FILES: 'Environmental/Cultural Restriction Files',
  LBL_REQUEST_HELP_LANDING_ZONE: 'Request help in choosing a landing zone?',
  LBL_HUMAN_EXTERNAL_CARGO: 'HEC (Human External Cargo)',
  LBL_HUMAN_EXTERNAL_CARGO_TYPE: 'HEC Type',
  LBL_EXTRA_EQUIPMENT: 'Any extra Equipment Over 50 lbs?',
  LBL_HELMENT_SUIT: 'Will you need Helmets and flight suits provided?',
  LBL_HAZMAT: 'Hazmat?',
  LBL_BASKET_REQUIRED: 'Basket Required?',
  LBL_BASKET_WEIGHT: 'Basket Weight (lbs)',
  LBL_ADD_OPERATOR_TAIL_NUMBER: 'New Operator and Tail Number Relationship',
  LBL_DELETE_OPERATOR_TAIL_NUMBER:
    'Delete Operator and Tail Number Relationship',
  LBL_MODIFY_OPERATOR_TAIL_NUMBER: 'Edit Operator and Tail Number Relationship',
  LBL_EDIT_REQUEST: 'Edit Request',
  LBL_UPLOAD_VIEW_FILES: 'Upload/View Files ({0})',
  LBL_DUPLICATE_REQUEST: 'Duplicate Request',
  LBL_RISK_ASSESSMENT: 'Risk Assessment',
  LBL_RISK_ASSESSMENT_SCORE: 'Risk Assessment Score',
  LBL_CANCEL_FLIGHT: 'Cancel Flight',

  LBL_EQUIPMENT_TYPE: 'Equipment Type',
  LBL_EQUIPMENT_WEIGHT: 'Equipment Weight (lbs)',

  LBL_FILE_TYPE: 'File Type',
  LBL_FILE_NAME: 'File Name',
  LBL_FILE: 'File',
  LBL_FILE_ADD: 'Add File',

  LBL_FIRE_DISPATCH_DISPATCH_DATE: 'Date of Dispatch',
  LBL_FIRE_DISPATCH_DISPATCH_TIME: 'Time of Dispatch',
  LBL_FIRE_DISPATCH_LIFT_OFF_TIME: 'Time of Lift Off',
  LBL_FIRE_DISPATCH_RESPONSE_TIME: 'Response Time',
  LBL_FIRE_DISPATCH_RETURN_TIME: 'Return Time',
  LBL_FIRE_DISPATCH_FLIGHT_HOURS: 'Flight Hours',
  LBL_FIRE_DISPATCH_DISPATCH_STATUS: 'Dispatch Status',
  LBL_FIRE_DISPATCH_LOCATION: 'Location',
  LBL_FIRE_DISPATCH_LATITUDE: 'Latitude',
  LBL_FIRE_DISPATCH_LAT_LONG: 'Lat Long',
  LBL_FIRE_DISPATCH_LONGITUDE: 'Longitude',
  LBL_FIRE_DISPATCH_HELICOPTER_COMPANY: 'Helicopter Company',
  LBL_FIRE_DISPATCH_TAIL: 'Tail #',
  LBL_FIRE_DISPATCH_PILOT: 'Pilot',
  LBL_FIRE_DISPATCH_COPILOT: 'Co-pilot',
  LBL_FIRE_DISPATCH_FLIGHT_NUMBER: 'Flight Number',
  LBL_FIRE_DISPATCH_FUEL_CYCLES: 'Fuel Cycles',
  LBL_FIRE_DISPATCH_LANDING_CYCLES: 'Landing Cycles',
  LBL_FIRE_DISPATCH_BILLABLE_LAUNCH: 'Billable Launch',
  LBL_FIRE_DISPATCH_NUM_OF_DIPS: 'No.of Dips',
  LBL_FIRE_DISPATCH_NUM_OF_DROPS: 'No.of Drops',
  LBL_FIRE_DISPATCH_WATER_DROPPED: 'Water Dropped',
  LBL_FIRE_DISPATCH_ACRES_BURNED: 'Acres Burned',
  LBL_FIRE_DISPATCH_FIRE_AGENCY: 'Fire Agency',
  LBL_FIRE_DISPATCH_FIRE_NAME: 'Fire Name',
  LBL_FIRE_DISPATCH_FIRE_COMMENTS: 'Fire Comments',
  LBL_FIRE_DISPATCH_STATUS: 'Status',
  LBL_FIRE_DISPATCH_STATUS_DISPATCHED: 'Dispatched',
  LBL_FIRE_DISPATCH_STATUS_IN_FLIGHT: 'In-Flight',
  LBL_FIRE_DISPATCH_STATUS_LANDED: 'Landed',
  LBL_FIRE_DISPATCH_STATUS_CANCELLED: 'Cancelled',
  LBL_FIRE_DISPATCH_STATUS_COMPLETED: 'Completed',
  LBL_FIRE_DISPATCH_REASON_COMMENTS: 'Reason / Comments',
  LBL_REASON_COMMENTS: 'Reason / Comments',
  LBL_REASON_CANCEL:
    'Please explain the reason for cancelling this flight request',
  LBL_REASON_DECLINE:
    'Please explain the reason for declining  this flight request',
  LBL_FIRE_DISPATCH_DETAILS: 'Details',
  LBL_FIRE_DISPATCH_CHANGE_LOGS: 'Change Logs',
  LBL_FIRE_DISPATCH_SDGE_BALANCE: 'SCG Balance',
  LBL_FIRE_DISPATCH_CUNTRY_HOURS: 'Country Hours',
  LBL_FIRE_DISPATCH_SDGE_HOURS: 'SCG Hours',
  LBL_FIRE_DISPATCH_SDGE_USD: 'SCG USD',
  LBL_FIRE_DISPATCH_CUNTRY_DUE: 'Country Due',
  LBL_NA: 'N/A',
  LBL_APPLY: 'Apply',
  LBL_CLEAR: 'Clear',
  LBL_TAR: 'TAR',
  LBL_TAR_REQUIRED: 'TAR Required',
  LBL_NIGHT_FLIGHT: 'Night Flight',
  LBL_DRONE_OTHER_QUESTION_1: 'Is flight occurring in controlled airspace?',
  LBL_DRONE_OTHER_QUESTION_2:
    'Are public safety concerns addressed in the comments?',
  LBL_DRONE_OTHER_QUESTION_3:
    'If flight is adjacent to or on private property, has the access protocol list been referenced or customer notifications coordinated?',
  LBL_TICKET_SEARCH: 'Enter Ticket Number',
  LBL_FLIGHT_SEARCH: 'Enter Flight Number',
  LBL_FILTERS: 'Filters',
  LBL_DRONE_OTHER_QUESTION_4: 'Is land management coordination required?',
  LBL_DRONE_OTHER_QUESTION_5:
    'Are there any environmental or cultural restrictions?',
  LBL_DRONE_OTHER_QUESTION_6: 'Have customer notifications been coordinated?',

  LBL_DRONE_OTHER_QUESTION_1_NOTE: 'If yes, upload the supporting documentation from the Endorsed Vendor',
  LBL_DRONE_OTHER_QUESTION_2_NOTE:
    'Mitigations for flight in populated areas or near roads.',
  LBL_DRONE_OTHER_QUESTION_3_NOTE:
    'ie: checked for sensitive customer, notifications through DNAde, door hangers, or in person.',
  LBL_DRONE_OTHER_QUESTION_4_NOTE:
    'ie: flight on state parks, tribal, BLM, USFS lands, Camp Pendleton.  If Yes, upload the supporting documentation.',
  LBL_DRONE_OTHER_QUESTION_5_NOTE:
    'ie: eagle awareness zones, CNF raptors, bighorn sheep, sunrise awareness area.  If Yes, upload the supporting documentation.',
  LBL_DRONE_OTHER_QUESTION_6_NOTE: 'ie: DNAde, door hangers, in person, etc.',
  LBL_HOURS: '{0} Hours',
  LBL_HOUR_MORE_THAN: 'More Than 8.0 Hours',
  LBL_POUNDS: '{0} lbs',

  LBL_AIR_OPS_PLAN: 'Air Ops Plan',
  LBL_LIFT_PLAN: 'Lift Plan Attached',
  LBL_SDGE_AOM_REVIEW_OPERATOR_COMPLIANCE:
    'SCG AOM On-Site, Reviewed, and Operator in Compliance',
  LBL_CONGESTED_AREA_PLAN: 'Congested Area Plan',
  LBL_LONG_LINE: 'Equipment Movement (Long Line Needed)',
  LBL_SHORT_HAUL_HEC: 'Short Haul/HEC',
  LBL_CREW_PRESENT: 'How many crew members are going to be present?',
  LBL_CREW_MOVEMENT: 'Crew Movement',
  LBL_SOCK_LINE_PULL: 'Sock Line/Wire Pull',
  LBL_ROPE_CONDUCTOR_SIZE: 'Rope/Conductor Sizes',
  LBL_FLYING_HAZMAT: 'Flying Hazmat? (ex. fuel, oil)',
  LBL_HEAVIEST_LOAD_WEIGHT: 'Weight of heaviest load (lbs)',
  LBL_PLATFORM_WORK: 'Platform Work',
  LBL_SKID_TRANSFER: 'Skid Transfer',
  LBL_SKID_BASKET: 'Skid Basket',
  LBL_POLE_SET: 'Pole Set',
  LBL_AIRCRAFT_TYPE: 'Aircraft Type',
  LBL_SDGE_TRACKER: 'SCG Tracker',

  LBL_DESCRIPTION_COMMENT: 'Descriptions/Comments',

  LBL_DISPATCH_FLIGHT_INFO: 'Dispatch Flight Info',
  LBL_DISPATCH_DATE_AND_TIME: 'Date & Time',
  LBL_LIFTOFF_AND_RETURN_TIME: 'Liftoff & Return Time',
  LBL_RESPONSE_TIME: 'Response Time',
  LBL_FIRE_INFO: 'Fire Info',
  LBL_FIRE_AGENCY: 'Fire Agency',
  LBL_NUMBER_OF_DIPS: 'No of Dips',
  LBL_GALLONS_DROPPED: 'Gallons Dropped',
  LBL_TICKET_NUMBER: 'Ticket No',
  LBL_TIME_SELECT: 'Ex: 1830',
  LBL_HOURS_SELECT: 'Ex: 2.5',
  LBL_L: 'L',
  LBL_R: 'R',
  LBL_ACRES_BURNED: 'Acres Burned:',
  LBL_DISPATCH_NUMBER: 'Dispatch No.',
  LBL_DISPATCHED: 'Dispatched',
  LBL_LANDED: 'Landed',
  LBL_DOWLOAD: 'Download',
  LBL_DISPATCH_DATE: 'Dispatch Date',
  LBL_FIRE_NAME: 'Fire Name',
  LBL_BILLABLE: 'Billable',
  LBL_DISPATCH_TIME: 'Dispatch Time',
  LBL_LIFTOFF_TIME: 'Lift off Time',
  LBL_SDGE_BALANCE: 'SCG_BLANCE',
  LBL_SDGE_HOURS: 'SCG_HOURS',
  LBL_SDGE_DOLLAR: 'SCG $',
  LBL_COUNTY_HOURS: 'County Hours',
  LBL_COUNTY_DOLLAR_DUE: 'County $ Due',
  LBL_AGENCY_HOURS: 'Agency Hours',
  LBL_AGENCY_DOLLAR_DUE: 'Agency $ Due',
  LBL_BILLABLE_LAUNCH: 'Billable Launch',
  LBL_FIRE_NAME_COMMENTS: 'Fire Name/ Comments',
  LBL_FLIGHT_STATUS: 'Flight Status',
  LBL_STATUS_DISPATCHED: 'Dispatched ({0})',
  LBL_STATUS_IN_FLIGHT: 'In-Flight ({0})',
  LBL_STATUS_LANDED: 'Landed ({0})',
  LBL_STATUS_CANCELLED: 'Cancelled ({0})',
  LBL_STATUS_COMPLETED: 'Completed ({0})',
  LBL_AOM_REVIEW: 'AOM reviewed?',
  LBL_TRACKING_DEVICE: 'ASD Tracking Device?',
  LBL_TWO_WAY_RADIO: "ASD Provided 'Two Way Radio'?",
  LBL_CONTACT_INFORMATION: 'Contact Information',
  LBL_PILOT_IN_COMMAND: 'Pilot In Command',
  LBL_PILOT_NUMBER: 'Cell Number (Pilot)',
  LBL_PRIME_CONTRACTOR: 'Prime Contractor',
  LBL_CONTACT_NAME: 'Contact Name',
  LBL_CONTRACTOR_NUMBER: 'Cell Number',
  LBL_CONTRACTOR_EMAIL: 'Contractor Email',
  LBL_TIE_LINES_CIRCUITS: 'Tie Lines/Circuits',
  LBL_NOISE_MONITORING: 'Noise Monitoring in Effect?',
  LBL_ADD_FAA_WAIVER_AUTH: 'FAA Waiver/Authorization Required?',
  LBL_FAA_INFORMATION: 'FAA Information: ',

  LBL_ADDRESS_CROSS_STREET: 'Project Address/Cross Street',
  LBL_FACILITY_ASSET_NUMBER: 'Facility or Asset #',
  LBL_LAND_MANAGEMENT_APPROVAL_REQUIREMENT:
    'Land Management Coordination Required?',
  LBL_LAND_MANAGEMENT_APPROVAL_REQUIREMENT_FILES:
    'Land Management Approval Files',
  LBL_ENVIRONMENTAL_CONCERN: 'Environmental Concerns?',
  LBL_PUBLIC_SAFETY_CONCERNS: 'Public Safety Concerns?',
  LBL_LIVESTOCK_CONCERNS: 'Livestock Concerns?',
  LBL_NOTIFICATION_SENT: 'Customer Notification Required',
  LBL_BRIEF_JOB_DESCRIPTION: 'Brief Job Description or Comments',
  LBL_OTHER_SPECIAL_COMMENTS: 'Other Comments or Special Concerns?',
  LBL_CONTRACTOR_NAME: 'Contractor Name',
  LBL_CONTRACTOR_COMPANY: 'Contractor Company',
  LBL_FLIGHT_OPERATOR: 'Flight Operator',

  LBL_EXU: 'EXU/CWN',
  LBL_OBSERVED: 'Observed',
  LBL_CONTRACTOR_MISSION: 'Contractor Mission',
  LBL_MCBCP_LONG_RIFLE_APPROVAL: 'MCBCP Long Rifle Approval',

  LBL_PLACEHOLDER_COST_CENTER: '_____-_____',
  LBL_SAVE_EXIT: 'Save & Exit',

  LBL_PILOT: 'A.) PILOT',
  LBL_ENVIRONMENT: 'B.) ENVIRONMENT',
  LBL_MISSION: 'C.) MISSION',
  LBL_ASSESSMENT_ADDITIONAL: 'Additional Considerations(Answers not required)',
  LBL_ASSESSMENT_PIC_EXPERIENCE_IN_MODAL: '1.) PIC Experience in Model',
  LBL_ASSESSMENT_PIC_EXPERIENCE_MISSION: '2.) PIC Experience in Mission',
  LBL_ASSESSMENT_PIC_CURRENCY_MISSION: '3.) PIC Currency in Mission',
  LBL_ASSESSMENT_CONSEC_DAYS_ON_DUTY: '4.) Consecutive Days On Duty',
  LBL_ASSESSMENT_DUTY_DAY: '5.) Duty Day',
  LBL_ASSESSMENT_DUTY_DAY_WOCL: 'WOCL if applicable:',
  LBL_ASSESSMENT_TIME_OF_DAY: '6.) Time Of Day',
  LBL_ASSESSMENT_CEILING_VISIBILITY: '7.) Ceiling / Visibility',
  LBL_ASSESSMENT_WINDS_IN_MISSION_AREA: '8.) Winds in Mission Area',
  LBL_ASSESSMENT_DENSITY_ALTITUDE: '9.) Density Altitude',
  LBL_ASSESSMENT_TERRAIN: '10.) Terrain',
  LBL_ASSESSMENT_MISSION_TYPE: '11.) Mission Type',
  LBL_ASSESSMENT_LANDING_ZONE: '12.) Landing Zone',
  LBL_ASSESSMENT_SECTION10: '',

  LBL_ASSESSMENT_A: 'a. Have I reviewed the IM SAFE checklist?',
  LBL_ASSESSMENT_B:
    'b. Are there any active NOTAMFS/TFRGs within operating area?',
  LBL_ASSESSMENT_C:
    'c. Are there any weather advisories expected for the next 24 hrs?',
  LBL_ASSESSMENT_D: 'd. When was the last time I flew in the operational area?',
  LBL_ASSESSMENT_E:
    'e. Are all involved personnel adequately trained and prepared?',
  LBL_ASSESSMENT_F: 'f. What is out of the ordinary today?',
  LBL_ASSESSMENT_G: 'g. Are operational pressures making me sacrifice safety?',
  LBL_ASSESSMENT_H: 'h. What is the riskiest evolution being done today?',
  LBL_ASSESSMENT_I: 'i. What can the FOB help with?',

  LBL_CHANGELOG_DATE_TIME: 'Change Date & Time',
  LBL_CHANGELOG_BY: 'Changed By',
  LBL_CHANGELOG_FIELD: 'Field',
  LBL_CHANGELOG_NEW_VALUE: 'New Value',
  LBL_CHANGELOG_OLD_VALUE: 'Old Value',
  LBL_READ_MORE: 'Read More',

  LBL_CONFIRM_DELETE: 'Yes, Delete',

  LBL_ACTUAL_FLIGHT_DATE: 'Actual Flight Date',
  LBL_REQUESTING_DEPARTMENT: 'Requesting Department',
  LBL_FLIGHT_CATEGORY: 'Flight Category',
  LBL_REQUEST_WORK_ORDER: 'Work Order #',

  LBL_VERIFY_FLIGHT_DATE: 'Verify Flight Date',
  LBL_GOTO_RISK_ASSESSMENT: 'Go To Risk Assessment',
  LBL_SENSITIVE_CITIES_COMMUNITIES: 'Sensitive Drone Areas',
  LBL_DRONE_AREAS_CITY_LOCATION: 'City/Location',
  LBL_ADD_DRONE_AREAS: 'New Sensitive Drone Area',
  LBL_DELETE_DRONE_AREAS: 'Delete Sensitive Drone Area',
  LBL_EDIT_DRONE_AREAS: 'Edit Sensitive Drone Area',
};
